import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Motorcycles from "./pages/Motorcycles";
import MotorcycleDetail from "./pages/MotorcycleDetail";
import Cars from "./pages/Cars";
import CarDetail from "./pages/CarDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import Login from "./pages/Login";
import AppointmentForm from "./pages/AppointmentForm";
import Chatbot from "./components/Chatbot";
import { AuthProvider, useAuth } from "./lib/auth";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-zinc-950 text-white flex items-center justify-center">Yükleniyor...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/sifir-motorlar" element={<Motorcycles condition="sifir" />} />
                <Route path="/ikinci-el-motorlar" element={<Motorcycles condition="ikinci-el" />} />
                <Route path="/motor/:id" element={<MotorcycleDetail />} />
                <Route path="/ikinci-el-araclar" element={<Cars />} />
                <Route path="/araba/:id" element={<CarDetail />} />
                <Route path="/hakkimizda" element={<About />} />
                <Route path="/iletisim" element={<Contact />} />
                <Route path="/randevu" element={<AppointmentForm />} />
                <Route path="/admin/login" element={<Login />} />
                <Route path="/admin" element={<Protected><Admin /></Protected>} />
              </Routes>
            </main>
            <Footer />
            <Chatbot />
            <Toaster theme="dark" position="top-right" />
          </BrowserRouter>
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
